import script from "./TimeTableGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeTableGridView.vue?vue&type=script&setup=true&lang=js"

import "./TimeTableGridView.vue?vue&type=style&index=0&id=6fd6d55e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd6d55e"]])

export default __exports__